module.exports = __webpack_public_path__ + "static/media/help_groceriesChannel_a.38d0417f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help_groceriesChannel_a.png
// module id = 639
// module chunks = 14